



// # 服務單 _ 銷單
export const is_Service_Delete_Sign = () => 
                    <span className = "tag is-medium is-rounded is-danger relative m_Left_20"  > 
                          <i className="fas fa-trash-alt"></i> &nbsp; 已銷單  
                    </span>